<template>
    <div class="infoMsg">
        <div class="infoLeft">
            <span>{{$t('route.customer')}}：{{ $route.query['scopeName'] }}</span>
            <div class="ml15">
                <span v-if="$route.query.sensorWay !== 'unbind'">{{$t('public.carrier')}}：{{ $route.query['carrierName'] }}</span>
                <i class="el-icon-tickets" @click="handleClick"></i>
            </div>
        </div>
        <sensorDetailDialog></sensorDetailDialog>
    </div>
</template>

<script>
import sensorDetailDialog from './sensorDetail/sensorDetailDialog.vue';
import bus from '@/utils/bus.js';
import { carrierDetail } from '@/utils/winDetail';

export default {
    components: {
        sensorDetailDialog
    },
    methods: {
        handleClick() {
            // bus.$emit("sensorParams", this.$route.query.id, this.$route.query.tagId);
            const { carrierId, carrierName, carrierTypeId } = this.$route.query;

            carrierDetail(carrierId, carrierName, carrierTypeId);
        }
    }
};
</script>

<style lang="scss" scoped>
.infoMsg {
    height: 40px;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .infoLeft {
        display: flex;

        .ml15 {
            margin-left: 15px;
        }

        i {
            cursor: pointer;
            margin-left: 5px;
        }
    }

    .infoRight {
        i {
            font-size: 18px;
            font-weight: bold;
            cursor: pointer;
        }
    }
}
</style>
